import type { ChangeEvent } from 'react';

const MAX_FRACTION_DIGITS = 2;

/**
 * Keeps only digits and a single decimal separator for currency-style text fields.
 * Fractional digits beyond hundredths are truncated (e.g. 10.267 → 10.26).
 */
export function sanitizeCurrencyAmountInput(raw: string): string {
  const stripped = raw.replace(/[^\d.]/g, '');
  const dotIndex = stripped.indexOf('.');
  if (dotIndex === -1) {
    return stripped;
  }
  const intPart = stripped.slice(0, dotIndex);
  const fracPart = stripped
    .slice(dotIndex + 1)
    .replace(/\./g, '')
    .slice(0, MAX_FRACTION_DIGITS);
  return `${intPart}.${fracPart}`;
}

export function changeEventWithSanitizedValue(
  e: ChangeEvent<HTMLInputElement>,
  value: string,
): ChangeEvent<HTMLInputElement> {
  if (value === e.target.value) {
    return e;
  }
  return {
    ...e,
    target: { ...e.target, value },
    currentTarget: e.currentTarget,
  } as ChangeEvent<HTMLInputElement>;
}
